import { eachTree } from "./tree"

export interface Option<T extends string | number = string> {
  label: string
  value: T
  disabled?: boolean
  children?: Option<T>[]
  [x: string]: any
}

export type ComboOption = Option & { node?: React.ReactNode }

export function option2map<T extends Option>(options: T[]) {
  const obj: Record<string, T> = {}
  eachTree(options, (item) => {
    const key = item.value
    obj[key] = item
  })
  return obj
}

export function customMatch(text: string, search: string) {
  return text.toLowerCase().includes(search.toLowerCase())
}

export function matchOption(option: Option, search: string) {
  if (!search) return true
  return customMatch(option.label, search)
}

export function filterOptions(options: Option[], filterValue: string) {
  return options.filter((option) => matchOption(option, filterValue))
}

export function formatHSCode(value: string) {
  // 只保留数字和小数点
  const cleanedValue = value.replace(/[^\d.]/g, "")
  // 移除所有小数点，只保留数字
  const digitsOnly = cleanedValue.replace(/\./g, "")

  // 限制最多输入27个数字
  const truncatedDigits = digitsOnly.slice(0, 27)

  // 5和7的时候格式化一下
  const digitLength = truncatedDigits.length
  //   五位数格式化
  if (digitLength === 5) {
    return `${truncatedDigits.slice(0, 4)}.${truncatedDigits.slice(4)}`
  }
  // 6位数格式化
  if (digitLength === 6) {
    // 处理12345.1这种情况，同时兼容1234.12.这种情况
    const val = `${truncatedDigits.slice(0, 4)}.${truncatedDigits.slice(4, 6)}`
    if (!cleanedValue.startsWith(val)) {
      return val
    }
  }
  // 7位数格式化
  if (digitLength === 7) {
    return `${truncatedDigits.slice(0, 4)}.${truncatedDigits.slice(4, 6)}.${truncatedDigits.slice(6)}`
  }

  return cleanedValue
}

export function string2Array(value: string, isNumber?: false): string[]
export function string2Array(value: string, isNumber: true): number[]
export function string2Array(
  value: string,
  isNumber?: boolean,
): (string | number)[] {
  if (value === "") {
    return []
  }
  const arr = value.split(",").filter((item) => item?.trim() !== "")
  if (isNumber) {
    return arr.map((item) => Number(item))
  }
  return arr
}

export function array2String(value: any[]) {
  return value.join(",")
}

export function formatInputNumber(value: string) {
  if (value === "0" || (value as any) === 0) return 0
  if (!Number(value)) {
    return undefined
  }
  return +value
}
